var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClaimsMenuIcon = function SvgClaimsMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 572",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 22,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 145",
    strokeLinecap: "round",
    d: "M6.5 5.5h5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 149",
    strokeLinecap: "round",
    d: "M5 10h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 151",
    strokeLinecap: "round",
    d: "M5 13h8"
  }))));
};

export { SvgClaimsMenuIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICA8ZyBpZD0iR3JvdXBfNTcyIiBkYXRhLW5hbWU9Ikdyb3VwIDU3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkyIC00ODIpIj4KICAgIDxnIGlkPSJSZWN0YW5nbGVfNzk1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3OTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkyIDQ4MikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjI0IiByeD0iMyIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMiIgcng9IjIiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxsaW5lIGlkPSJMaW5lXzE0NSIgZGF0YS1uYW1lPSJMaW5lIDE0NSIgeDI9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk4LjUgNDg3LjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0iTGluZV8xNDkiIGRhdGEtbmFtZT0iTGluZSAxNDkiIHgyPSI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NyA0OTIpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0iTGluZV8xNTEiIGRhdGEtbmFtZT0iTGluZSAxNTEiIHgyPSI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NyA0OTUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K";